import React from "react";
import autoBind from "react-autobind";
import feathers from "../../../feathers";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import {Panel} from "../../../components/Panel";
import noty from "../../../lib/noty";
import EditPermissionsToggles from "../../../components/PermissionsToggles/EditPermissions";
import EntityPermissionsToggles from "../../../components/PermissionsToggles/EntityPermissions";
import FacilityPermissionsToggles from "../../../components/PermissionsToggles/FacilityPermissions";
import "./style.scss";

// Split an array into two arrays with equal(ish) length
// TODO: this could be used to put the markerTypeCategories
// in alpha order down their columns...but it will be a PIA
// const splitArray = (array) => {
//   const middle = Math.ceil(array.length / 2)
//   return [
//     array.slice(0, middle),
//     array.slice(middle, array.length)
//   ]
// }

export default class Invitation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fetching: false,
      touched: false,
      invitation: this.props.invitation,
      options: {
        facilities: [],
        buildings: [],
        markerTypeCategories: [],
        groups: []
      }
    };
    autoBind(this);
  }

  async componentDidMount() {
    const options = await feathers.service("api/permissions-options").find();
    this.setState({options});
  }

  handleArrayChange({name, value}) {
    const path = ["permissions", ...name.split(".")];
    const {invitation} = this.state;
    const array = invitation.getIn(path);
    if (value.toggle === true) {
      this.setState({
        touched: true,
        invitation: invitation.setIn(path, [...array, value.value])
      });
    } else {
      this.setState({
        touched: true,
        invitation: invitation.setIn(path, array.filter(_id => _id !== value.value))
      });
    }
  }

  handleFacility(facility, allChecked) {
    const path = ["permissions", "resources", "buildings"];
    const {invitation} = this.state;
    const buildingIds = facility.buildings.map(building => building._id);
    const currentBuildings = invitation.getIn(path);
    if (!allChecked) {
      // Use Set() to dedupe potential dupilicates
      const newBuildingIds = Array.from(new Set([...currentBuildings, ...buildingIds]));
      this.setState({
        touched: true,
        invitation: invitation.setIn(path, newBuildingIds)
      });
    } else {
      this.setState({
        touched: true,
        invitation: invitation.setIn(path, currentBuildings.filter(_id => !buildingIds.includes(_id)))
      });
    }
  }

  toggleAll({name, value}) {
    const path = ["permissions", ...name.split(".")];
    if (value.toggle === true) {
      this.setState({
        touched: true,
        invitation: this.state.invitation.setIn(path, value.value)
      });
    } else {
      this.setState({
        touched: true,
        invitation: this.state.invitation.setIn(path, [])
      });
    }
  }

  handleChange({name, value}) {
    const path = ["permissions", ...name.split(".")];
    this.setState({
      touched: true,
      invitation: this.state.invitation.setIn(path, value)
    });
  }

  handleEmailChange({name, value}) {
    const path = name.split(".");
    this.setState({
      touched: true,
      invitation: this.state.invitation.setIn(path, value)
    });
  }

  handleSubmit() {
    const {invitation} = this.state;
    this.setState({fetching: true});
    invitation
      .patch()
      .then(invitation => {
        this.setState({
          fetching: false,
          touched: false
        });
        noty.success("Invitation Updated.");
      })
      .catch(err => {
        this.setState({fetching: false});
        noty.errors(err);
      });
  }

  handleRemove() {
    const {invitation} = this.state;
    noty.confirm(`Are you sure you want to delete this invitation?`, {
      onOk: () => {
        this.setState({fetching: true});
        invitation
          .remove()
          .then(removed => {
            noty.success("Invitation removed.");
          })
          .catch(err => {
            this.setState({fetching: false});
            noty.errors(err);
          });
      }
    });
  }

  handleResend() {
    const {invitation} = this.state;
    noty.confirm(`Are you sure you want to resend this invitation?`, {
      onOk: () => {
        this.setState({fetching: true});
        invitation
          .resend()
          .then(removed => {
            noty.success("Invitation resent.");
          })
          .catch(err => {
            noty.errors(err);
          })
          .finally(() => {
            this.setState({fetching: false});
          });
      }
    });
  }

  render() {
    const {invitation, options, fetching, touched} = this.state;
    const permissions = invitation.permissions;
    const {buildings, markerTypeCategories} = permissions.resources;
    const {groups} = permissions;
    return (
      <div id="Invitation" className="margin-bottom-30">
        <Panel
          onSaveClick={this.handleSubmit}
          saveTitle="Update user invitation"
          onDeleteClick={this.handleRemove}
          fetching={fetching}
          touched={touched}
          touchedMessage="Are you sure that you want to leave? This user has unsaved changes."
          checkCanAdd="users">
          <div style={{padding: "0 16px"}}>
            <div className="row" style={{margin: "16px 0"}}>
              <div className="col-xs-12">
                <InvitationProfile invitation={invitation} />
              </div>
            </div>
            <Divider />
            <EditPermissionsToggles permissions={permissions} onChange={this.handleChange} disabled={fetching} />
          </div>
          <div style={{margin: "40px 0", padding: "0 16px"}}>
            <p>
              Choose which resources the user can view. This is different from the options above where you may limit
              whether the user has account and resource editing capabilities.
            </p>
          </div>
          <div className="row" style={{padding: "0 16px"}}>
            <FacilityPermissionsToggles
              title="Facilities"
              className="col-md-5 col-sm-12 margin-bottom-30"
              entityArray={buildings}
              options={options}
              onChange={this.handleArrayChange}
              toggleAll={this.toggleAll}
              toggleFacility={this.handleFacility}
              disabled={fetching}
            />
            <EntityPermissionsToggles
              title="Marker Type Categories"
              className="col-md-7 col-sm-12 margin-bottom-30"
              entityArray={markerTypeCategories}
              entityName="resources.markerTypeCategories"
              options={options.markerTypeCategories}
              onChange={this.handleArrayChange}
              toggleAll={this.toggleAll}
              disabled={fetching}
            />
          </div>
          <div style={{margin: "40px 0", padding: "0 16px"}}>
            <p>Assign optional groups for this user. Groups can be used to search for users.</p>
          </div>
          <div className="row" style={{padding: "0 16px"}}>
            <EntityPermissionsToggles
              title="User Groups"
              className="col-md-5 col-sm-12 margin-bottom-30"
              entityArray={groups}
              entityName="groups"
              options={options.groups}
              onChange={this.handleArrayChange}
              toggleAll={this.toggleAll}
              disabled={fetching}
            />
          </div>
          <div className="col-sm-12">
            <Button label="Resend Invitation" color="primary" onClick={this.handleResend} />
          </div>
        </Panel>
      </div>
    );
  }
}

const InvitationProfile = ({invitation}) => (
  <div className="profile-container">
    <Avatar src="/img/default-profile.png" />
    <div className="profile-text">
      <p>{invitation.email}</p>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/Account/Invitation/index.jsx